import callApi from 'res-api-cli/build/callApi';
import type { EvidenceBundleStatusResponse } from 'components/Complaints/Complaint/EvidenceV2/types/bundle';

/**
 * GET /cms/evidence-bundles/{id}
 *
 * Polls the status of an in-flight or completed ZIP bundle job.
 * cms responds with Cache-Control: no-store and re-checks visibility on every call.
 *
 * Possible statuses:
 *   PENDING  — lambda is still assembling the ZIP
 *   READY    — ZIP is built; downloadUrl is a fresh ~15-min pre-signed URL
 *   FAILED   — lambda reported an error; error field is populated
 *   EXPIRED  — ZIP was lifecycle-deleted before the SPA polled
 *   CONSUMED — /complete was already called; download is done
 *
 * @see CD-7668 plan — Task 3.2
 */
const getEvidenceBundleStatus = (bundleId: string, opts: Record<string, unknown> = {}): Promise<EvidenceBundleStatusResponse> =>
  callApi({
    ...opts,
    method: 'GET',
    url: `/cms/evidence-bundles/${encodeURIComponent(bundleId)}`,
  });

export default getEvidenceBundleStatus;
